import { EVENTS, subscribe } from 'ia-util-pubsub'

export class IaProductCardGallery extends HTMLElement {
  connectedCallback() {
    this.variantChangeUnsubscriber = subscribe(EVENTS.variantChange, this.handleVariantChange.bind(this))
  }

  disconnectedCallback() {
    this.variantChangeUnsubscriber()
  }

  handleVariantChange({ detail }) {
    const { html, variant } = detail
    if (!variant || detail.productId !== this.productId) return

    // Try to use variant image directly first (works for product cards in drawers)
    const variantImage = variant.featured_image || variant.image
    if (variantImage) {
      const imageUrl = typeof variantImage === 'object' && variantImage !== null 
        ? (variantImage.src || variantImage.url) 
        : (typeof variantImage === 'string' ? variantImage : null)
      
      if (imageUrl) {
        this.updateImage(imageUrl)
        return
      }
    }

    // Fallback: try HTML lookup (for main product context where sectionId matches)
    if (!html || detail.sectionId !== this.sectionId) return

    // Find the new gallery HTML from the loaded variant section
    const newGallery = html.querySelector(`ia-product-card-gallery[product-id="${this.productId}"]`)
    if (!newGallery) return

    // Replace the current image with the new one
    const newImage = newGallery.querySelector('img')
    const currentImage = this.querySelector('img')
    
    if (newImage && currentImage) {
      currentImage.src = newImage.src
      currentImage.alt = newImage.alt
      if (currentImage.hasAttribute('srcset')) {
        currentImage.srcset = newImage.srcset
        currentImage.sizes = newImage.sizes
      }
    }
  }

  get sectionId() {
    return this.getAttribute('section-id')
  }

  get productId() {
    return this.getAttribute('product-id')
  }

  updateImage(imageUrl) {
    const currentImage = this.querySelector('img')
    if (!currentImage || !imageUrl) return
    currentImage.src = imageUrl
    if (currentImage.hasAttribute('srcset')) {
      currentImage.removeAttribute('srcset')
      currentImage.removeAttribute('sizes')
    }
  }
}

customElements.define('ia-product-card-gallery', IaProductCardGallery)